var exports = {
  "LL": "LexicalMessageComposer.module__editable___LVhfVU",
  "h5": "LexicalMessageComposer.module__richInputHost___LVhfVU",
  "I8": "LexicalMessageComposer.module__formSize___LVhfVU",
  "FY": "LexicalMessageComposer.module__paragraph___LVhfVU",
  "qf": "LexicalMessageComposer.module__placeholder___LVhfVU",
  "xL": "LexicalMessageComposer.module__marker___LVhfVU",
  "_u": "LexicalMessageComposer.module__blockquoteLine___LVhfVU",
  "iU": "LexicalMessageComposer.module__blockquoteMarker___LVhfVU",
  "Cr": "LexicalMessageComposer.module__bold___LVhfVU",
  "TN": "LexicalMessageComposer.module__italic___LVhfVU",
  "V1": "LexicalMessageComposer.module__underline___LVhfVU",
  "ZN": "LexicalMessageComposer.module__strike___LVhfVU",
  "aY": "LexicalMessageComposer.module__code___LVhfVU",
  "Po": "LexicalMessageComposer.module__mentionHost___LVhfVU",
  "ZJ": "LexicalMessageComposer.module__emojiHost___LVhfVU",
  "G5": "LexicalMessageComposer.module__command___LVhfVU",
  "Gx": "LexicalMessageComposer.module__slashSlot___LVhfVU",
  "Pe": "LexicalMessageComposer.module__slashSlotPlaceholder___LVhfVU",
  "ZW": "LexicalMessageComposer.module__slashSlotSeparator___LVhfVU",
  "Q$": "LexicalMessageComposer.module__optionalHint___LVhfVU",
};

module.exports = exports;
